var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-input-search',{staticClass:"ll-search",attrs:{"disabled":_vm.disabled || _vm.loading,"loading":_vm.loading,"placeholder":_vm.placeholder,"allow-clear":""},on:{"input":_vm.handleInput,"search":_vm.handleSearch},scopedSlots:_vm._u([{key:"addonBefore",fn:function(){return [_c('lander-icon',{attrs:{"type":"search"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }